import { render } from "./ListaUnidadesSelect.vue?vue&type=template&id=2c1f858c&scoped=true"
import script from "./ListaUnidadesSelect.vue?vue&type=script&lang=js"
export * from "./ListaUnidadesSelect.vue?vue&type=script&lang=js"

import "./ListaUnidadesSelect.vue?vue&type=style&index=0&id=2c1f858c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1f858c"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection,QTooltip});
